module.exports = __webpack_public_path__ + "img/copy.e825bd13.svg";